import styled from 'styled-components';
import noop from 'utils/noop';
import { colors } from 'ui/theme';
import { DashboardEmptyState } from 'ui/icons/dashboard';

const EmptyStateContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
  &:hover {
    background: ${colors.grey15};
  }
`;

const CONTENT = {
  addWidgetCta: 'Add widget',
};

type Props = {
  handleClick: () => void;
};

export const DashboardPlaceholder = ({ handleClick = noop }: Props) => {
  return (
    <EmptyStateContainer onClick={handleClick}>
      <DashboardEmptyState />
      <span>{CONTENT.addWidgetCta}</span>
    </EmptyStateContainer>
  );
};
